export default "/public/dist/img/Certificazionefoto_2.jpg";